﻿import React from 'react';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import store from './store';
import { themeConfig } from './config/theme';
import { CountryProvider } from './context/CountryContext';
import AppRouter from './router/AppRouter';
import './index.css';
import 'react-quill-new/dist/quill.snow.css';

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
          <h2 style={{ color: '#0f172a', fontWeight: 700 }}>Something went wrong</h2>
          <p style={{ color: '#64748b' }}>Please refresh the page or try again later.</p>
          <button onClick={() => window.location.reload()} style={{ padding: '8px 24px', borderRadius: 8, background: '#56B0FF', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <ConfigProvider theme={themeConfig}>
          <CountryProvider>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </CountryProvider>
        </ConfigProvider>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
